import { render, staticRenderFns } from "./CandidatesList.vue?vue&type=template&id=d5c45d8a&scoped=true"
import script from "./candidatesList.ts?vue&type=script&lang=ts&external"
export * from "./candidatesList.ts?vue&type=script&lang=ts&external"
import style0 from "./CandidatesList.vue?vue&type=style&index=0&id=d5c45d8a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c45d8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5c45d8a')) {
      api.createRecord('d5c45d8a', component.options)
    } else {
      api.reload('d5c45d8a', component.options)
    }
    module.hot.accept("./CandidatesList.vue?vue&type=template&id=d5c45d8a&scoped=true", function () {
      api.rerender('d5c45d8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/client/candidates/candidates-list/CandidatesList.vue"
export default component.exports